import { render, staticRenderFns } from "./UserBoard.vue?vue&type=template&id=6f8831a6"
import script from "./UserBoard.vue?vue&type=script&lang=js"
export * from "./UserBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports